import React from 'react'
import ProfileHead from './components/ProfileHead'
import InterestsBlock from './components/InterestsBlock'
// import PrivateDataMessage from './components/PrivateDataMessage'
import InfoBlock from './components/InfoBlock'

export default function MainView() {
  return (
    <React.Fragment>
      <ProfileHead />
      <InterestsBlock />
      <InfoBlock />
    </React.Fragment>
  )
}
